export default "__VITE_ASSET__7831cc7d__"